<template>
    <div class="location-info" v-if="data && data.name">
        <h2 class="location-info__heading" v-text="data.name"></h2>
        <p class="location-info__text" v-text="data.description" v-if="data.description"></p>
        <div class="location-info__temp" v-if="data.waterTemperature || data.airTemperature">
            <p v-text="temperatureDates"></p>
            <div class="temp-info">
                <div class="temp-info__item" v-if="data.waterTemperature">
                    <img src="./../../img/icons/icon-temp-water.svg" alt="">
                    <span> {{ data.waterTemperature }}&deg;C</span>
                </div>
                <div class="temp-info__item" v-if="data.airTemperature">
                    <img src="./../../img/icons/icon-temp-sun.svg" alt="">
                    <span>{{ data.airTemperature }}&deg;C</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    export default {
        props: {
            data: {type: Object, default() { return { }}}
        },
        data() {
            return {
                translations: APP_CONFIG.TRANSLATION.LOCATION_INFO
            }
        },
        computed: {
            temperatureDates() {
                if(!this.data.fromDate) {
                    return '';
                }

                return  this.translations.degrees + ' ' + this.data.fromDate.format('DD/MM') + ' - ' + this.data.toDate.format('DD/MM');
            }
        }
    }
</script>